import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=13081a82&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13081a82')) {
      api.createRecord('13081a82', component.options)
    } else {
      api.reload('13081a82', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=13081a82&", function () {
      api.rerender('13081a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y4WXRjo6y6H0/JS/comp/ImgFallback.vue"
export default component.exports